<div class="flex flex-col" [formGroup]="formGroup">
    @if (label) {
        <div class="hypo-input-label">
            {{ label }}
            @if (showOptionalLabel()) {
                <span class="optional"></span>
            }
            @if (tooltip) {
                <app-tooltip [text]="tooltip"></app-tooltip>
            }
        </div>
    }

    <mat-form-field [class.has-info]="tooltip" [floatLabel]="'always'">
        <mat-select
            disableOptionCentering
            formControlName="mainInput"
            placeholder="Vyberte možnost"
            [attr.data-testid]="testId"
            searchable>
            <mat-option>
                @if (searchAble) {
                    <ngx-mat-select-search
                        [formControl]="searchControl"
                        noEntriesFoundLabel="Nenalezeno"
                        placeholderLabel="Vyhledat"
                        [attr.data-testid]="testId + '-search'">
                    </ngx-mat-select-search>
                }
            </mat-option>
            @for (filteredOption of showingList; track trackByValue($index, filteredOption)) {
                <mat-option [value]="filteredOption.value" [attr.data-testid]="testId + ':' + filteredOption.value">
                    {{ filteredOption.label }} {{ valueVisibleInLabel ? '- ' + filteredOption.value : '' }}
                </mat-option>
            }
            <ng-content></ng-content>
        </mat-select>
        @if (input.hasError('required')) {
            <mat-error align="end"> Povinný údaj </mat-error>
        }
    </mat-form-field>
</div>
